export const GET_LOGIN_REQUEST = "GET_LOGIN_REQUEST"
export const SET_LOGIN_REQUEST = "SET_LOGIN_REQUEST"
export const LOGOUT_REQUEST = "LOGOUT_REQUEST"